var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"visible":_vm.visible,"cancelDialog":_vm.cancelDialog,"confirmDialog":_vm.cancelDialog,"width":_vm.width}},[_c('img',{ref:"img",staticClass:"priviewImg",attrs:{"src":_vm.fileUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }